




































    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import TablePager from '@/components/TablePager.vue';
    import TableField from '@/types/TableField';
    import TableSortEventArgs from '@/types/TableSortEventArgs';
    import PagerOptions, { InitPagerOptions } from '@/types/PagerOptions';
    import SortOptions from '@/types/SortOptions';
    import { BTable, BButton, BIconArrowUp, BIconArrowDown, BSpinner } from 'bootstrap-vue';
    import OperationFilterOptions from '@/types/OperationFilterOptions';
    import Configuration from '@/types/Configuration';
    import InlineSvg from 'vue-inline-svg';
    import ColumnHeader from '@/components/ColumnHeader.vue';
    import AxiosService from '@/services/axiosService';
    import i18n from '../i18n';

    @Component({
        components: {
            'table-pager': TablePager,
            'b-table': BTable,
            'b-btn': BButton,
            'b-icon-arrow-up': BIconArrowUp,
            'b-icon-arrow-down': BIconArrowDown,
            'inline-svg': InlineSvg,
            'column-header': ColumnHeader,
            'b-spinner': BSpinner
        }
    })
	export default class OperationList extends Vue {
        @Prop() refresh!: boolean
        @Prop() filter!: OperationFilterOptions

        operations: OperationListItem[] = [];
        listOptions: OperationListOptions = {
            filter: this.filter,
            pagerOptions: {
                page: 1,
                pageSize: 100, //Configuration.DefaultPageSize,
                pageCount: 1,
                rowCount: 0,
                rowStart: 0,
                rowEnd: 0
            },
            sortOptions: {
                sortBy: 'id',
                sortDirection: Configuration.SortDirectionAscending
            }
        };
        isBusy = false;
        apiAccessToken = this.$store.state.apiAccessToken;

        fields: TableField[] = [
			{
                key: 'id',
                label: 'fields.name',
                headerTitle: 'Name',
                sortable: true,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg font-weight-bolder py-4',
                formatter: null
            }
        ];

        @Watch('refresh')
        refreshList(newVal: boolean) {
            if (newVal) {
                this.loadOperations();
            }
        }

        @Watch('filter')
        filterList(newVal: OperationFilterOptions) {
            this.listOptions.filter = newVal;
            this.listOptions.pagerOptions.page = 1;
        }

        mounted() {
            this.isBusy = false;
            this.apiAccessToken = this.$store.state.apiAccessToken;
            this.loadOperations();
        }

        async loadOperations() {
            //this.isBusy = true;
            //this.listOptions.pagerOptions.pageSize = 0;

            try {
                const response = await AxiosService.request<ServerData>({
                    url: `operationsadministration/list`,
                    method: 'POST',
                    data: this.listOptions
                });

                this.operations = response.data.records ?? [];
                this.listOptions.pagerOptions = InitPagerOptions(response.data.totalRecordCount, response.data.pageCount, this.listOptions.pagerOptions.page, this.listOptions.pagerOptions.pageSize);
            }
            catch (error) {
                if (error.response) {
                    switch (error.response.status) {
                        case 404:
                            return this.$router.push(`/${i18n.locale}/notfound`);
                        case 403:
                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                        default:
                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                    }
                }
            }
            finally {
                this.isBusy = false;
                this.$emit('load-complete');
            }
        }

        onChangePage(page: number) {
            this.listOptions.pagerOptions.page = page;
            this.loadOperations();
        }

        onChangePageSize(pageSize: number) {
            this.listOptions.pagerOptions.pageSize = pageSize;
            this.listOptions.pagerOptions.page = 1;
            this.loadOperations();
        }

        onSortChanged(e: TableSortEventArgs) {
            this.listOptions.sortOptions.sortBy = e.sortBy;
            this.listOptions.sortOptions.sortDirection = e.sortDesc ? -1 : 1;
            this.loadOperations();
        }
	}

	interface ServerData {
        records: OperationListItem[];
        totalRecordCount: number;
        pageCount: number;
	}

    interface OperationListItem {
        id: string;
        actions: string;
    }

    interface OperationListOptions {
        filter: OperationFilterOptions;
        pagerOptions: PagerOptions;
        sortOptions: SortOptions;
    }
